<template>
  <!-- 销售网点 -->
  <div class="commercialNetWorks">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="网点名称">
              <a-input
                placeholder="请选择网点名称"
                v-model="queryParam.name"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" @click="handleAdd" style="margin-top: 5px"
        >新增</a-button
      >
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel"
            ><a-icon type="primary" />批量删除</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>
    <a-table
      ref="table"
      rowKey="subId"
      bordered
      :columns="columns1"
      :dataSource="dataSource"
      :pagination="ipagination"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange
      }"
      @change="handleTableChange"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a @click="handleDelete(record)">删除</a>
      </span>
    </a-table>
    <!-- 弹窗 -->
    <a-modal
      :footer="null"
      :title="title"
      @cancel="handleCancel"
      :visible="visible"
      :width="width"
    >
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete" />删除</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </a-modal>
    <!-- 新增弹窗 -->
    <a-drawer
      :width="800"
      title="新增销售网点"
      :visible="visibleShow"
      placement="right"
      :closable="true"
      :maskClosable="true"
      @close="handleCancelShow"
      style="overflow: auto; padding-bottom: 53px"
    >
      <a-table
        :rowKey="
          (record, index) => {
            return index;
          }
        "
        :rowSelection="{
          selectedRowKeys: selectedRowKey,
          onChange: onSelectChanges
        }"
        bordered
        :dataSource="addDataSourceMessage"
        :columns="columns2"
        :pagination="ipaginations"
        @change="handleTableChanges"
      >
      </a-table>
      <div class="drawer-bootom-button">
        <a-popconfirm
          title="确定放弃编辑？"
          @confirm="handleCancel"
          okText="确定"
          cancelText="取消"
        >
          <a-button style="margin-right: 0.8rem">取消</a-button>
        </a-popconfirm>
        <a-button @click="handleOk" type="primary">提交</a-button>
      </div>
    </a-drawer>
    <commercialNetWorksModal
      ref="modalForm"
      @ok="modalFormOk"
    ></commercialNetWorksModal>
  </div>
</template>

<script>
import { getAction, postAction, postTag } from '@/api/manage';
import { filterObj } from '@/utils/util';
import commercialNetWorksModal from './commercialNetWorksModal.vue'; //编辑页面
import customRender from '@/utils/customRender.js';
const columns1 = [
  {
    title: '网址',
    dataIndex: 'web',
    align: 'center'
  },
  {
    title: '客服电话',
    dataIndex: 'mobile',
    align: 'center'
  },
  {
    title: '网点名称',
    dataIndex: 'name',
    align: 'center'
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    // fixed:"right",
    width: 147,
    scopedSlots: {
      customRender: 'action'
    }
  }
];
const columns2 = [
  {
    title: '机构名称',
    dataIndex: 'web',
    align: 'center'
  },
  {
    title: '客服电话',
    dataIndex: 'mobile',
    align: 'center'
  },
  {
    title: '官网网址',
    dataIndex: 'name',
    align: 'center'
  }
];
export default {
  components: {
    commercialNetWorksModal
  },
  data() {
    return {
      columns1,
      columns2, //新增table数据
      visible: false,
      visibleShow: false,
      popoverShow: false, //气泡弹出
      width: 1200,
      addDataSourceMessage: [], //新增数据
      selectedRowKeys: [],
      selectionRows: [],
      //
      selectedRowKey: [],
      selectionRow: [],

      queryParam: {
        //查询数据
        name: '',
        automatic: ''
      },
      loading: false,
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      ipaginations: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      fundCode: '',
      fundId: '',
      title: '当前销售网点',
      url: {
        list:
          process.env.VUE_APP_CMS_PRODUCT + '/product/organization/sub/page', //查询
        delete:
          process.env.VUE_APP_CMS_PRODUCT + '/product/organization/sub/delete', //删除
        //所有销售网点
        listAll:
          process.env.VUE_APP_CMS_PRODUCT + '/product/organization/sub/list',
        add: process.env.VUE_APP_CMS_PRODUCT + '/product/organization/sub/add', //添加
        deleteBatch:
          process.env.VUE_APP_CMS_PRODUCT +
          '/product/organization/sub/deleteBatch' //批量删除
      },
      dataSource: []
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    //查询当下所有数据
    getList(arg) {
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      let that = this;
      let params = this.getQueryParams();
      this.fundCode = this.$route.query.fundCode;
      this.fundId = this.$route.query.fundId;
      params.fundCode = this.fundCode;
      postTag(that.url.list, params)
        .then(res => {
          that.dataSource = res.result.records;
          that.ipagination.total = res.result.total;
          that.loading = false;
        })
        .finally(() => {
          that.loading = false;
        });
    },
    handleCancel() {
      this.visible = false;
      this.visibleShow = false;
      this.onClearSelected();
    },
    handleEdit(record) {
      this.$refs.modalForm.edit(record);
    },
    //点击新增获取数据
    handleAdd() {
      this.visibleShow = true;
      this.getAllList();
      // this.onClearSelected()
    },
    // 获取点中时的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      console.warn(selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    // 获取点中时的数据
    onSelectChanges(selectedRowKeys, selectionRows) {
      this.selectedRowKey = selectedRowKeys;
      this.selectionRow = selectionRows;
    },
    //删除
    handleDelete(record) {
      console.log(record);
      let that = this;
      that.$confirm({
        title: '确认删除',
        content: '确定要删除吗',
        onOk: function() {
          that.loading = true;
          postTag(that.url.delete + `?subId=${record.subId} `, {})
            .then(res => {
              if (res.success) {
                that.getList(1);
                that.$message.success(res.message);
              } else {
                that.$message.error(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        }
      });
    },
    // 批量删除
    batchDel() {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        let ids = '';
        for (let a = 0; a < this.selectionRows.length; a++) {
          ids += this.selectionRows[a].subId + ',';
          console.log(this.selectionRows, ids);
        }
        console.log(ids);
        let that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function() {
            that.loading = true;
            postAction(that.url.deleteBatch, { ids: ids })
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.getList();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          }
        });
      }
    },
    //新增销售网点弹窗关闭点击事件
    handleCancelShow() {
      this.visibleShow = false;
      this.onClearSelected();
    },
    //获取所有网点数据
    getAllList() {
      let that = this;
      let param = {
        pageNo: this.ipaginations.current,
        pageSize: this.ipaginations.pageSize,
        fundCode: this.$route.query.fundCode
      };
      postTag(that.url.listAll, param).then(res => {
        that.loading = true;
        if (res.success) {
          that.addDataSourceMessage =
            res.result && res.result.records ? res.result.records : [];
          that.ipaginations.total = res.result.total;
          that.loading = false;
        }
      });
    },
    //分页
    handleTableChange(pagination) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      this.ipagination = pagination;
      this.getList();
    },
    handleTableChanges(pagination) {
      this.onClearSelected(); //分页切换时清空表格选中
      this.ipaginations = pagination;
      this.getAllList();
    },
    //清空选中的数据
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
      this.selectionRow = [];
      this.selectedRowKey = [];
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.getList();
    },
    handleOk() {
      let that = this;
      let result = {
        fundId: this.fundId
        // organizationIds:
      };
      let proxycode = [];
      if (this.selectionRow.length <= 0) {
        return that.$message.warning('请选择一条记录');
      }
      this.selectionRow.forEach(item => {
        proxycode.push(item.organizationId);
      });
      result.organizationIds = proxycode;
      postTag(that.url.add, result).then(res => {
        if (res.success) {
          that.loading = false;
          that.visibleShow = false;
          that.onClearSelected();
          that.getList(1);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //获取查询条件
    getQueryParams() {
      let sqp = {};
      let param = Object.assign(sqp, this.queryParam);
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },

    searchQuery() {
      this.getList(1);
    },
    //searchReset
    searchReset() {
      this.queryParam = {};
      this.getList(1);
    }
  }
};
</script>

<style scoped>
.formType {
  display: flex;
  justify-content: space-between;
}
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
